import React, { Component } from 'react'
import menu from '../../menu';
import {
    FacebookShareButton,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    VKShareButton,
    OKShareButton,
    RedditShareButton,
    TumblrShareButton,
    LivejournalShareButton,
    MailruShareButton,
    ViberShareButton,
    WorkplaceShareButton,
    LineShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    TelegramIcon,
    WhatsappIcon,
    GooglePlusIcon,
    LinkedinIcon,
    PinterestIcon,
    VKIcon,
    OKIcon,
    RedditIcon,
    TumblrIcon,
    LivejournalIcon,
    MailruIcon,
    ViberIcon,
    WorkplaceIcon,
    LineIcon,
    EmailIcon,
} from 'react-share';

class Share extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Description: "",
            Title: "",
            URL: "https://developer.nexoid.com/",
        }

        for (var i = 0; i < menu.length; i++) {
            if (menu[i].section.toLowerCase() === this.props.section.toLowerCase()) {
                for (var a = 0; a < menu[i].menu.length; a++) {
                    if (menu[i].menu[a].heading !== true) {
                        if (menu[i].menu[a].link.toLowerCase() === this.props.article.toLowerCase()) {
                            this.state.Title = menu[i].menu[a].title;
                            this.state.URL = "https://developer.nexoid.com/" + menu[i].section + '/' + menu[i].menu[a].link;
                            this.state.Description = menu[i].menu[a].description;
                            a = menu[i].menu.length;
                        }
                    }
                }
                i = menu.length;
            }

        }
        // console.log("menu", menu)
        // console.log("state", this.state)
        // console.log("props", this.props)
    }

    NexoidEmailBody(title, desc, url) {
        var ret = '';
        // ret += 'Nexoid Developer Documentation - ' + title + '%0D%0A';
        // ret += desc + '%0D%0A';
        ret += url;
        return ret;
    }

    render() {




        return (
            <div style={{ textAlign: "right" }}>
                Share with...<br />
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <EmailShareButton subject={this.state.Title} body={this.NexoidEmailBody(this.state.Title, this.state.Description, this.state.URL)} url={this.state.URL}><EmailIcon size={32} round={true} /> </EmailShareButton>
                </div>
                {/* <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <WorkplaceShareButton title={this.state.description} quote={this.state.Description} url={this.state.URL}><WorkplaceIcon size={32} round={true} /> </WorkplaceShareButton>
                </div> */}
                {/* <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <TumblrShareButton title={this.state.description} caption={this.state.Description} url={this.state.URL}><TumblrIcon size={32} round={true} /> </TumblrShareButton>
                </div> */}
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <RedditShareButton title={this.state.Description} description={this.state.Description} url={this.state.URL}><RedditIcon size={32} round={true} /> </RedditShareButton>
                </div>
                {/* <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <TelegramShareButton title={this.state.Title} url={this.state.URL}><TelegramIcon size={32} round={true} /> </TelegramShareButton>
                </div> */}
                {/* <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <GooglePlusShareButton url={this.state.URL}><GooglePlusIcon size={32} round={true} /> </GooglePlusShareButton>
                </div> */}
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <WhatsappShareButton title={this.state.Title} url={this.state.URL}><WhatsappIcon size={32} round={true} /> </WhatsappShareButton>
                </div>
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <LinkedinShareButton title={this.state.Title} description={this.state.Description} url={this.state.URL}><LinkedinIcon size={32} round={true} /> </LinkedinShareButton>
                </div>
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <TwitterShareButton title={this.state.Title} url={this.state.URL}><TwitterIcon size={32} round={true} /> </TwitterShareButton>
                </div>
                <div style={{ cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 }}>
                    <FacebookShareButton quote={this.state.Description} url={this.state.URL}><FacebookIcon size={32} round={true} /> </FacebookShareButton>
                </div>
            </div>
        );
    }
}

export default Share


// WEBPACK FOOTER //
// ./src/components/Footer/Share.js